import { useState } from "react";
import api from "../api/api";

export default function Contacts() {
  const [contacts, setContacts] = useState([]);

  const [form, setForm] = useState({
    contact_id: "",
    name: "",
    email: "",
    mobile_no: "",
    comp_id: "",
  });

  const [page, setPage] = useState(1);
  const perPage = 5;

  //  LOAD CONTACTS
 const load = async () => {
  try {
    const res = await api.get(`/contact`);
    setContacts(res.data || []);
    setPage(1);
  } catch (err) {
    console.log("LOAD ERROR", err.response?.data);
    alert(err.response?.data?.message || "Error loading data");
  }
};

  //  CREATE CONTACT
  const create = async () => {
    const { contact_id, name, email, mobile_no, comp_id } = form;

    //  validation
    if (!contact_id || !name || !email || !mobile_no || !comp_id) {
      return alert("All fields required");
    }

    //  mobile validation
    if (mobile_no.length < 10) {
      return alert("Enter valid mobile number");
    }

    try {
      const res = await api.post("/contact", {
        contact_id: contact_id.trim(),
        name,
        email,
        mobile_no,
        comp_id,
      });

      alert("Contact Added");

      // reset form (comp_id same rahega)
      setForm({
        contact_id: "",
        name: "",
        email: "",
        mobile_no: "",
        comp_id: comp_id,
      });

      load();
    } catch (err) {
      console.log("CREATE ERROR", err.response?.data);
      alert(err.response?.data?.message || "Server Error");
    }
  };

  // PAGINATION (FIXED)
  const totalPages = Math.max(1, Math.ceil(contacts.length / perPage));
  const start = (page - 1) * perPage;
  const data = contacts.slice(start, start + perPage);

  return (
    <div className="min-h-screen -mt-10">
      <h2 className="text-4xl font-semibold text-[#030244] text-center mb-8">
        Contact Form
      </h2>

      <div className="max-w-lg mx-auto bg-white shadow-lg rounded-xl p-8 mb-6 border">
        <div className="flex flex-col gap-4">
          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Contact ID"
            value={form.contact_id}
            onChange={(e) => setForm({ ...form, contact_id: e.target.value })}
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Company ID"
            value={form.comp_id}
            onChange={(e) => setForm({ ...form, comp_id: e.target.value })}
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Mobile"
            value={form.mobile_no}
            onChange={(e) => setForm({ ...form, mobile_no: e.target.value })}
          />
        </div>

        {/* BUTTONS */}
        <div className="flex justify-center gap-4 mt-8">
          <button
            onClick={create}
            className="bg-[#030244] hover:bg-[#01038b] text-white px-6 py-2 text-lg rounded"
          >
            Add Contact
          </button>

          <button
            onClick={load}
            className="bg-green-700 hover:bg-green-600 text-white px-6 py-2 text-lg rounded"
          >
            Load Contacts
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="max-w-5xl mx-auto bg-white shadow rounded-xl overflow-hidden mt-12">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px]">
            <thead className="bg-[#030244] text-white text-xl">
              <tr>
                <th className="p-3 text-center border font-medium">ID</th>
                <th className="p-2 text-center border font-medium">Company ID</th>
                <th className="p-3 text-center border font-medium">Name</th>
                <th className="p-3 text-center border font-medium">Email</th>
                <th className="p-3 text-center border font-medium">Mobile</th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center p-4 text-xl">
                    No Data Found
                  </td>
                </tr>
              ) : (
                data.map((c) => (
                  <tr key={c.contact_id} className="border-b hover:bg-gray-50 text-lg">
                    <td className="p-3 text-center border text-gray-700">{c.contact_id}</td>
                    <td className="p-3 text-center border text-gray-700">{c.comp_id}</td>
                    <td className="p-3 text-center border text-gray-700">{c.name}</td>
                    <td className="p-3 text-center border text-gray-700">{c.email}</td>
                    <td className="p-3 text-center border text-gray-700">{c.mobile_no}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          disabled={page === 1}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          className="bg-[#030244] text-white px-4 py-2 rounded disabled:opacity-50"
        >
          Prev
        </button>

        <button
          disabled={page >= totalPages}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          className="bg-[#030244] text-white px-4 py-2 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}
